<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'base.create_blank' | translate }}
    v-card-content
      .cols-x
        .cols-x__2
          v-input-r(
            :label="$t('base.farm_name')"
            :hint="errorMessage('name')"
            :invalid="!!errorMessage('name')"
            @input="clearError('name')"
            v-model="payload.name")
        .cols-x__2
          v-input-r(
            :label="$t('base.struct_manager')"
            v-model="payload.structure_manager")
      .cols-x
        .cols-x__2
          v-input-r(
            :label="$t('base.company')"
            v-model="payload.company_name")
        .cols-x__2
          v-input-r(
            :label="$t('base.farm_manager')"
            v-model="payload.farm_manager")
      .cols-x
        .cols-x__2
          v-input-r(
            :label="$t('base.ind_code')"
            v-model="payload.ind_code")
        .cols-x__2
          v-input-r(
            :label="$t('base.zootechnic')"
            v-model="payload.zootechnics")
      .cols-x
        .cols-x__2
          v-input-r(
            :label="$t('base.struct')"
            v-model="payload.structure_name")
        .cols-x__2
          v-input-r(
            :label="$t('base.accountant')"
            v-model="payload.accountant")
      .cols-x
        .cols-x__2
          v-input-r(
            :label="$t('base.farm')"
            v-model="payload.farm_full_name")
        .cols-x__2
          v-input-r(
            :label="$t('base.weigher')"
            v-model="payload.weigher")
      v-input-r(
        :label="$t('base.destination')"
        v-model="payload.appoint")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="onCreate") {{ 'base.create' | translate }}
</template>

<script>
import { mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'CreateModal',
  mixins: [formErrorsMixin],

  data: () => ({
    payload: {
      name: '',
      company_name: '',
      ind_code: '',
      structure_name: '',
      farm_full_name: '',
      appoint: '',
      structure_manager: '',
      farm_manager: '',
      zootechnics: '',
      accountant: '',
      weigher: ''
    },
    errors: {
      name: null
    },
    loading: false
  }),

  methods: {
    ...mapActions('additional', [
      'createAdditional'
    ]),

    checkValidData () {
      const errorCodes = { REQUIRED: '4' }
      let valid = true

      if (!this.payload.name || !this.payload.name.trim()) {
        this.errors.name = [errorCodes.REQUIRED]
        valid = false
      }

      if (!valid) {
        this.loading = false
        return false
      }

      return true
    },

    async onCreate () {
      this.loading = true

      if (!this.checkValidData()) return

      const payload = {
        farm: this.$route.params.farm_id,
        ...this.payload
      }
      const error = await this.createAdditional(payload)
      this.loading = false
      if (!error) {
        this.$emit('close')
      } else {
        this.$toasted.error(this.$t('errors.incorrect_data'))
      }
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

</style>